export const SET_HISTORIETYPEN = 'set_historietypen';
export const SET_HISTORIETYPEN_LOADED = 'set_historietypen_loaded';
